import { Mail, MapPin, Phone } from "lucide-react";
import { useTranslations } from "next-intl";
import Link from "next/link";

const MAPS_HREF =
  "https://www.google.com/maps/search/?api=1&query=B%C9%99%C5%9Fir+B%C3%BCnyadov+k%C3%BC%C3%A7.+134";

function HighlightedTitle({ title, highlight }: { title: string; highlight: string }) {
  const index = highlight ? title.indexOf(highlight) : -1;
  if (!highlight || index === -1) return <>{title}</>;
  return (
    <>
      {title.slice(0, index)}
      <span className="home-highlight">{highlight}</span>
      {title.slice(index + highlight.length)}
    </>
  );
}

const rowClass =
  "home-contact-row flex min-h-11 w-full items-center gap-4 rounded-home-16 border-[1.5px] border-home-navy bg-home-cream px-[18px] py-[14px] text-home-navy";

export function ContactInfoPanel() {
  const t = useTranslations("contact");

  return (
    <div className="flex h-full w-full flex-1 flex-col justify-between gap-10 rounded-home-28 border-[1.5px] border-home-navy bg-[linear-gradient(135deg,var(--home-cream-2),var(--home-cream))] p-[clamp(28px,4vw,48px)]">
      <div>
        <span className="inline-flex items-center gap-2 rounded-home-pill border-[1.5px] border-home-navy px-4 py-2 text-[15px] font-semibold uppercase tracking-[0.04em] text-home-navy">
          <span
            aria-hidden="true"
            className="h-2 w-2 rounded-full bg-home-accent animate-home-blink motion-reduce:animate-none"
          />
          {t("eyebrow")}
        </span>
        <h2 className="mt-5 text-balance text-[clamp(36px,4.4vw,56px)] font-bold leading-[1.04] tracking-[-0.02em] text-home-navy">
          <HighlightedTitle title={t("title")} highlight={t("highlight")} />
        </h2>
      </div>

      <div className="flex flex-col gap-[14px]">
        <Link href="tel:+994002222222" className={rowClass}>
          <span className="home-contact-icon flex h-11 w-11 shrink-0 items-center justify-center rounded-[12px] bg-home-navy text-home-cream">
            <Phone className="h-5 w-5" aria-hidden="true" />
          </span>
          <span className="min-w-0 text-[19px] font-semibold leading-snug">+994 00 222 22 22</span>
        </Link>

        <Link href="mailto:info.tender.az" className={rowClass}>
          <span className="home-contact-icon flex h-11 w-11 shrink-0 items-center justify-center rounded-[12px] bg-home-navy text-home-cream">
            <Mail className="h-5 w-5" aria-hidden="true" />
          </span>
          <span className="min-w-0 text-[19px] font-semibold leading-snug">info.tender.az</span>
        </Link>

        <a href={MAPS_HREF} target="_blank" rel="noopener noreferrer" className={rowClass}>
          <span className="home-contact-icon flex h-11 w-11 shrink-0 items-center justify-center rounded-[12px] bg-home-navy text-home-cream">
            <MapPin className="h-5 w-5" aria-hidden="true" />
          </span>
          <span className="min-w-0 text-[19px] font-semibold leading-snug">Bəşir Bünyadov küç. 134</span>
        </a>
      </div>
    </div>
  );
}
